<template>
  <a-spin size="large" :spinning="dmSpinning">
    <div v-if="dmHasStatus">
      <p>
        <a-icon
          type="check-circle"
          theme="twoTone"
          twoToneColor="#52c41a"
          v-if="dmStatus.status === 'succeeded'"
        />
        <a-icon type="close-circle" theme="twoTone" twoToneColor="red" v-else />
        Custom domain setup {{dmStatus.status}}
      </p>
      <p>
        <a-icon
          type="check-circle"
          theme="twoTone"
          twoToneColor="#52c41a"
          v-if="dmStatus.acm_status === 'cert issued'"
        />
        <a-icon type="close-circle" theme="twoTone" twoToneColor="red" v-else />
        HTTPS {{dmStatus.acm_status}}
      </p>
      <p v-if="dmStatus.acm_status === 'cert issued'">
        <a-icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /> CNAME pointing to
        <span class="cname disabled">{{dmStatus.proxy}}</span>
        <a-icon
          type="copy"
          style="fontSize:20px;cursor: pointer; padding:5px;"
          v-clipboard:copy="dmStatus.proxy"
          @click="success"
        />
      </p>
      <p v-else>
        <a-alert type="error">
          <p slot="message">Validating CNAME</p>
          <div slot="description">
            <p>It may take upto 24hrs to provision Let's Encrypt certificate for your domain. Make sure you have created a CNAME record for your domain with following value.</p>
            <span class="cname disabled">{{dmStatus.proxy}}</span>
            <a-icon
              type="copy"
              style="fontSize:20px;cursor: pointer; padding:5px;"
              v-clipboard:copy="dmStatus.proxy"
              @click="success"
            />
          </div>
        </a-alert>
      </p>
    </div>
    <div v-else>
      <p>
        <a-icon type="close-circle" theme="twoTone" twoToneColor="red" v-if="dmStatusError" />
        {{dmStatusError}}
      </p>
    </div>
  </a-spin>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["dmHasStatus", "dmSpinning", "dmStatus", "dmStatusError"],
  methods: {
    success() {
      this.$message.success("CNAME copied.", 5);
    }
  }
};
</script>